import {Money, VatTypeEnum} from '@dms/api/shared';

export type PriceRequestBody = {
  /**
   * Price w/o VAT or price w VAT
   */
  price: Money;
  /**
   * Is price with VAT?
   */
  isWithVat: boolean;
  /**
   * Type of VAT
   */
  vatType: VatTypeEnum;
};
